package com.shadowings.gero.data.lessons.chapter3

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.foundation.layout.Column
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.QuizText
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_prima_di_addentrarci_nelle_regole_delle_frasi
import gero.composeapp.generated.resources.exp_content_ricorda_di_norma_i_sostantivi_femminili_termi
import gero.composeapp.generated.resources.exp_content_ripasso_finito
import gero.composeapp.generated.resources.exp_title_maschile_vs_femminile
import gero.composeapp.generated.resources.exp_title_mettiti_alla_prova
import gero.composeapp.generated.resources.exp_title_ripasso_genere_e_numero
import gero.composeapp.generated.resources.exp_title_singolare_vs_plurale
import gero.composeapp.generated.resources.plural_dual
import gero.composeapp.generated.resources.plural_triple
import gero.composeapp.generated.resources.plural_w
import gero.composeapp.generated.resources.quiz_ripasso_cosa_significa_gero
import gero.composeapp.generated.resources.quiz_ripasso_quale_gero_significa
import gero.composeapp.generated.resources.quiz_ripasso_traslitterazione

fun getRipassoGenereNumeroContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_ripasso_genere_e_numero,
            content = Res.string.exp_content_prima_di_addentrarci_nelle_regole_delle_frasi,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_maschile_vs_femminile,
            content = Res.string.exp_content_ricorda_di_norma_i_sostantivi_femminili_termi,
            face = Faces.Serious,
            composable = {
                Column {
                    MdCWord(word = "W19-M17-M17-X1:F27", rtl = false, cart = false) // gatta
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_singolare_vs_plurale,
            content = Res.string.plural_w,
            face = Faces.Surprised,
            composable = {
                Column {
                    MdCWord(word = "A47-G43-G43-A1", rtl = false, cart = false) // pastori
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_singolare_vs_plurale,
            content = Res.string.plural_triple,
            face = Faces.Surprised,
            composable = {
                Column {
                    MdCWord(word = "A47-G43-A1-Z3", rtl = false, cart = false) // pastori
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_singolare_vs_plurale,
            content = Res.string.plural_dual,
            face = Faces.Surprised,
            composable = {
                Column {
                    MdCWord(word = "A47-G43-A1-A1", rtl = false, cart = false) // pastori
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_mettiti_alla_prova,
            content = Res.string.exp_content_ripasso_finito,
            face = Faces.Perfect
        )
    )
}

fun getRipassoGenereNumeroQuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    val targetIds = listOf(
        "UOMO", "DONNA", "DONNE", "PADRE", "MADRE",
        "PASTORE", "PASTORI", "SACERDOTE", "SACERDOTI", "SCRIBA", "SCRIBI",
        "GATTO", "GATTA", "GATTI", "GATTE", "FALCO", "FALCHI",
        "TORO", "TORI", "MUCCA", "MUCCHE", "PESCE", "PESCI",
        "ALBERO", "ALBERI"
    )

    val filteredWords = targetIds.mapNotNull { id -> words.find { it.id == id } }
    val selectedWords = filteredWords.shuffled().take(16)

    val quizList = mutableListOf<IQuizContent>()

    selectedWords.forEachIndexed { i, word ->
        val otherVaryingWords = filteredWords.filter { it.id != word.id }

        // Randomly choose between select-hieroglyph (0) or select-meaning (1) quiz types
        if (i % 2 == 0) {
            // Select Hieroglyph: Ask for the hieroglyph given the meaning
            val options = mutableListOf(Option(word.gardiner, correct = true))
            options.addAll(
                otherVaryingWords.shuffled().take(3).map { Option(it.gardiner, correct = false) })

            quizList.add(
                SingleSelectionContent(
                    text = Res.string.quiz_ripasso_quale_gero_significa,
                    textArgs = listOf(word.inlineMeaning(languageCode)),
                    detail = "",
                    options = options.shuffled()
                )
            )
        } else {
            // Select Meaning: Ask for the meaning given the hieroglyph
            val options = mutableListOf(Option(word.getMeaning(languageCode), correct = true))
            options.addAll(
                otherVaryingWords.shuffled().take(3)
                    .map { Option(it.getMeaning(languageCode), correct = false) })

            quizList.add(
                SingleSelectionContent(
                    text = Res.string.quiz_ripasso_cosa_significa_gero,
                    detail = word.gardiner,
                    options = options.shuffled(),
                    info = QuizText.Resource(
                        Res.string.quiz_ripasso_traslitterazione,
                        listOf(word.reading)
                    )
                )
            )
        }
    }

    return quizList.shuffled()
}
